import { apiClient } from './client';

export interface FeatureFlagDto {
  flagKey: string;
  name: string;
  enabled: boolean;
  description: string | null;
  updatedAt: number;
  updatedBy: string;
}

interface ServiceResponse<T> {
  code: number;
  message: string;
  data: T;
  requestId: string;
}

export interface ListFeatureFlagsResponse {
  items: FeatureFlagDto[];
  total: number;
}

export async function listFeatureFlags(): Promise<ListFeatureFlagsResponse> {
  const resp = await apiClient.get<ServiceResponse<ListFeatureFlagsResponse>>('/feature-flags');
  return resp.data.data;
}

export async function updateFeatureFlag(flagKey: string, enabled: boolean): Promise<FeatureFlagDto> {
  const resp = await apiClient.patch<ServiceResponse<FeatureFlagDto>>(
    `/feature-flags/${encodeURIComponent(flagKey)}`,
    { enabled },
  );
  return resp.data.data;
}

